<template>
  <div class="parent">
    <!-- 조간 메뉴 -->
    <div class="gnb" v-if="this.type == 0 || this.type == 3">
      <ul>
        <li>
          <button @click="onClickMenu"><menu-icon :size="30" fill-color="#555" /><span>전체</span></button>
        </li>
        <li>
          <button @click="onClickMove('1.')"><img src="/icon/1news.png" height="30" /><span>주요이슈</span></button>
        </li>
        <li>
          <button @click="onClickMove('6.')"><img src="/icon/7spetheme.png" height="30" /><span>특징테마</span></button>
        </li>
        <li>
          <button @click="onClickMove('7.')"><img src="/icon/8uplimitspe.png" height="30" /><span>특징주</span></button>
        </li>
        <li>
          <button @click="onClickMove('8.')"><img src="/icon/9outtimespe.png" height="30" /><span>시간외</span></button>
        </li>
        <li>
          <button @click="onClickMove('9.')"><img src="/icon/10altup.png" height="30" /><span>대체거래소</span></button>
        </li>
      </ul>
    </div>
    <!-- 중간 메뉴 -->
    <div class="gnb" v-if="this.type == 1">
      <ul>
        <li>
          <button @click="onClickMenu"><menu-icon :size="30" fill-color="#555" /><span>전체</span></button>
        </li>
        <li>
          <button @click="onClickMove('1.')"><img src="/icon/1news.png" height="30" /><span>주요이슈</span></button>
        </li>
        <li>
          <button @click="onClickMove('2.')"><img src="/icon/15popular.png" height="30" /><span>테마동향</span></button>
        </li>
        <li>
          <button @click="onClickMove('3.')"><img src="/icon/8uplimitspe.png" height="30" /><span>특징주</span></button>
        </li>
        <li>
          <button @click="onClickMove('4.')"><img src="/icon/21spe.png" height="30" /><span>기술적 분석</span></button>
        </li>
        <li>
          <button @click="onClickMove('6.')"><img src="/icon/20announce.png" height="30" /><span>주요 공시</span></button>
        </li>
      </ul>
    </div>
    <!-- 석간 메뉴 -->
    <div class="gnb" v-if="this.type == 2">
      <ul>
        <li>
          <button @click="onClickMenu"><menu-icon :size="30" fill-color="#555" /><span>전체</span></button>
        </li>
        <li>
          <button @click="onClickMove('1.')"><img src="/icon/1news.png" height="30" /><span>주요이슈</span></button>
        </li>
        <li>
          <button @click="onClickMove('4.')"><img src="/icon/7spetheme.png" height="30" /><span>특징테마</span></button>
        </li>
        <li>
          <button @click="onClickMove('5.')"><img src="/icon/8uplimitspe.png" height="30" /><span>특징주</span></button>
        </li>
        <li>
          <button @click="onClickMove('6.')"><img src="/icon/9outtimespe.png" height="30" /><span>시간외</span></button>
        </li>
        <li>
          <button @click="onClickMove('11.')"><img src="/icon/20announce.png" height="30" /><span>주요 공시</span></button>
        </li>
      </ul>
    </div>
    <div class="menu_wrap" v-if="this.menuOpen">
      <div class="menu">
        <div class="logo_title">
          <div class="logo_img">
            <div style="flex: 1"><img src="/logo.png" width="180" /></div>
            <button @click="onClickMenuClose"><close-icon :size="30" fill-color="#555" style="display: block" /></button>
          </div>
          <div class="title_txt">인포스탁 모바일 주식 신문</div>
          <div>{{ this.dateTime }}</div>
        </div>
        <div class="menu_list">
          <!-- 조간 전체메뉴 -->
          <ul v-if="this.type == 0 || this.type == 3">
            <li>
              <button @click="onClickMove('1.')"><img src="/icon/1news.png" height="42" /><span>주요 이슈</span></button>
            </li>
            <li>
              <button @click="onClickMove('2.')"><img src="/icon/2schedule1.png" height="42" /><span>스케줄</span></button>
            </li>
            <li>
              <button @click="onClickMove('3.')">
                <img src="/icon/4amspec.png" height="42" /><span>미국 시황/<br />특징주</span>
              </button>
            </li>
            <li>
              <button @click="onClickMove('4.')">
                <img src="/icon/5ametf.png" height="42" /><span>미국 기업/<br />ETF 등락률</span>
              </button>
            </li>
            <li>
              <button @click="onClickMove('5.')"><img src="/icon/6koindex.png" height="42" /><span>국내 시황</span></button>
            </li>
            <li>
              <button @click="onClickMove('6.')"><img src="/icon/7spetheme.png" height="42" /><span>특징 테마</span></button>
            </li>
            <li>
              <button @click="onClickMove('7.')">
                <img src="/icon/8uplimitspe.png" height="42" /><span>특징주<br />상한가/급등주</span>
              </button>
            </li>
            <li>
              <button @click="onClickMove('8.')">
                <img src="/icon/9outtimespe.png" height="42" /><span>시간외<br />특징주</span>
              </button>
            </li>
            <li>
              <button @click="onClickMove('9.')">
                <img src="/icon/10altup.png" height="42" /><span>대체거래소<br />상승/하락</span>
              </button>
            </li>
            <li>
              <button @click="onClickMove('10.')">
                <img src="/icon/11techanaly.png" height="42" /><span>기술적<br />분석</span>
              </button>
            </li>
            <li>
              <button @click="onClickMove('11.')">
                <img src="/icon/12newrecom.png" height="42" /><span>증권사<br />신규 추천</span>
              </button>
            </li>
            <li>
              <button @click="onClickMove('12.')">
                <img src="/icon/13forcorp.png" height="42" /><span>외국인, 기관<br />순매매 종목</span>
              </button>
            </li>
            <li>
              <button @click="onClickMove('13.')">
                <img src="/icon/14forcorpout.png" height="42" /><span>외국인/기관<br />연속 순매수 등</span>
              </button>
            </li>
            <li>
              <button @click="onClickMove('14.')"><img src="/icon/17shortstocksell.png" height="42" /><span>공매도</span></button>
            </li>
            <li>
              <button @click="onClickMove('15.')"><img src="/icon/18creditrate.png" height="42" /><span>신용 비율</span></button>
            </li>
            <li>
              <button @click="onClickMove('16.')">
                <img src="/icon/19histockloan.png" height="42" /><span>하이스탁론<br />매수/상환</span>
              </button>
            </li>
            <li>
              <button @click="onClickMove('17.')"><img src="/icon/20announce.png" height="42" /><span>주요 공시</span></button>
            </li>
            <li v-if="this.type == 0">
              <button @click="onClickMove('18.')">
                <img src="/icon/24hand.png" height="42" /><span>자사주 취득<br />중/완료 기업</span>
              </button>
            </li>
            <li v-if="this.type == 3">
              <button @click="onClickMove('18.')">
                <img src="/icon/16foreign.png" height="42" /><span>자사주<br />보유비율</span>
              </button>
            </li>
            <li v-if="this.type == 3">
              <button @click="onClickMove('19.')">
                <img src="/icon/24hand.png" height="42" /><span>자사주 취득<br />중/완료 기업</span>
              </button>
            </li>
          </ul>
          <!-- 중간 전체메뉴 -->
          <ul v-if="this.type == 1">
            <li>
              <button @click="onClickMove('1.')"><img src="/icon/1news.png" height="42" /><span>주요 이슈</span></button>
            </li>
            <li>
              <button @click="onClickMove('2.')"><img src="/icon/15popular.png" height="42" /><span>테마 동향</span></button>
            </li>
            <li>
              <button @click="onClickMove('3.')"><img src="/icon/8uplimitspe.png" height="42" /><span>특징주</span></button>
            </li>
            <li>
              <button @click="onClickMove('4.')"><img src="/icon/21spe.png" height="42" /><span>기술적 분석</span></button>
            </li>
            <li>
              <button @click="onClickMove('5.')">
                <img src="/icon/13forcorp.png" height="42" /><span>외국계<br />순매수,도</span>
              </button>
            </li>
            <li>
              <button @click="onClickMove('6.')"><img src="/icon/20announce.png" height="42" /><span>주요 공시</span></button>
            </li>
          </ul>
          <!-- 석간 전체메뉴 -->
          <ul v-if="this.type == 2">
            <li>
              <button @click="onClickMove('1.')"><img src="/icon/1news.png" height="42" /><span>주요 이슈</span></button>
            </li>
            <li>
              <button @click="onClickMove('2.')"><img src="/icon/6koindex.png" height="42" /><span>국내 시황</span></button>
            </li>
            <li>
              <button @click="onClickMove('3.')">
                <img src="/icon/23price.png" height="42" /><span>아시아<br />시황</span>
              </button>
            </li>
            <li>
              <button @click="onClickMove('4.')"><img src="/icon/7spetheme.png" height="42" /><span>특징 테마</span></button>
            </li>
            <li>
              <button @click="onClickMove('5.')">
                <img src="/icon/8uplimitspe.png" height="42" /><span>특징주<br />상한가/급등주</span>
              </button>
            </li>
            <li>
              <button @click="onClickMove('6.')">
                <img src="/icon/9outtimespe.png" height="42" /><span>시간외<br />특징주</span>
              </button>
            </li>
            <li>
              <button @click="onClickMove('7.')">
                <img src="/icon/11techanaly.png" height="42" /><span>기술적<br />분석</span>
              </button>
            </li>
            <li>
              <button @click="onClickMove('8.')">
                <img src="/icon/13forcorp.png" height="42" /><span>외국인, 기관<br />순매매 종목</span>
              </button>
            </li>
            <li>
              <button @click="onClickMove('9.')"><img src="/icon/22uplimit.png" height="42" /><span>인기 검색</span></button>
            </li>
            <li>
              <button @click="onClickMove('10.')">
                <img src="/icon/24hand.png" height="42" /><span>1억원 이상<br />매수/매도</span>
              </button>
            </li>
            <li>
              <button @click="onClickMove('11.')"><img src="/icon/20announce.png" height="42" /><span>주요 공시</span></button>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div v-html="html" style="padding-bottom: 57px"></div>
    <div class="top_button">
      <button @click="onClickTop"><img src="/icon/btn_top.png" height="32" /></button>
    </div>
  </div>
  <!-- 오류메세지 주석 -->
  <!-- <div >화면 로딩중입니다...</div> -->
</template>

<script>
import MenuIcon from "vue-material-design-icons/Menu.vue";
import CloseIcon from "vue-material-design-icons/Close.vue";
export default {
  name: "NewsPaper",
  components: {
    MenuIcon,
    CloseIcon,
  },
  data() {
    return {
      type: null, // 0:조간, 1:중간, 2:석간, 3:월요조간
      menuOpen: false,
      dateTime: "",
      html: "화면 로딩중입니다...",
    };
  },

  created() {
    // 2022.04 suki - 주식신문 url이 너무 길어서 newsid, memberid 를 관리하는 테이블 추가(MPaperManage)
    // news id 와 index 로 path 를 만들고
    // 맨앞에 m , h 로 member path 인지 homepage path 인지 구분한다.
    // h 로 시작하면 session 으로 체크하고 뒤에 붙는 건 newsid 만 붙인다.
    // m 로 시작하면 newsid 뒤 index 를 분리하고
    // MPaperManage 테이블에서 newsid 와 index 로 조회해서 처리 한다.
    const spath = this.$route.params.spath;

    this.getNewsPaper({ id: spath });
  },

  methods: {
    getNewsType(htmlString) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, "text/html");
      const paragraphs = doc.querySelectorAll(".dateBox");
      this.dateTime = paragraphs[0].innerText;
      const dateString = paragraphs[0].innerText.replaceAll(". ", "-").replace(" 초판", "");
      try {
        const date = new Date(dateString);
        const nowDay = date.getDay();
        const nowHour = date.getHours();
        const nowMin = date.getMinutes();
        if (nowHour === 6 && nowMin === 58) {
          if (nowDay !== 1) {
            return 0; // 조간
          } else {
            return 3; // 조간(월요일)
          }
        } else if (nowHour === 11 && nowMin === 30) {
          return 1; // 중간
        } else if (nowHour === 18 && nowMin === 30) {
          return 2; // 석간
        } else {
          return null;
        }
      } catch (error) {
        console.error("신문일자 구분 실패");
        return null;
      }
    },
    getNewsPaper(param) {
      console.log("getNewsPaper = param=", param);
      this.$axios
        .post("/newspaper/view", param)
        .then((result) => {
          console.log("getNewsPaper = result=", result);
          if (result.data.success) {
            console.log(result.data);
            const { content } = result.data.data;
            // 오류메세지 주석
            // this.$router.push({
            //   name: "NewsPaperDone",
            //   params: {html: content },
            // });
            this.html = content;
            console.log();
            this.type = this.getNewsType(this.html);
            this.addJavascript();
          } else {
            this.$router.push({ name: "Error", params: { mesg: result.data.message } });
          }
        })
        .catch((err) => {
          console.log("err=", JSON.stringify(err));

          //if (process.env.NODE_ENV === 'development') return // 개발환경에서는 page push X
          //let message = err.message
          this.$router.push({ name: "Error", params: { mesg: JSON.stringify(err) } });
          // 오류메세지 주석
          // this.$router.push({ name: 'Error', params:{mesg:'네트워크 오류가 발생했습니다! <br/>잠시 후 다시 시도해 주세요'} })
        });
    },
    scrollToText(searchText) {
      const paragraphs = document.querySelectorAll(".newsSelectList a.menu-anchor");
      let foundElement = null;
      for (let i = 0; i < paragraphs.length; i++) {
        if (paragraphs[i].textContent.includes(searchText)) {
          foundElement = paragraphs[i];
          break;
        }
      }
      if (foundElement) {
        let parentElement = foundElement.parentElement.parentElement;
        if (!parentElement.classList.contains("on")) {
          foundElement.click();
        }
        foundElement.scrollIntoView({
          block: "start",
        });
      } else {
        //alert(`"${searchText}" 텍스트를 찾을 수 없습니다.`);
        return;
      }
    },
    addJavascript() {
      const newsPaperScript = document.createElement("script");
      newsPaperScript.setAttribute("src", "https://news.infostock.co.kr/staticserving/js/newspaper.js");
      document.head.appendChild(newsPaperScript);
    },
    onClickMove(key) {
      this.menuOpen = false;
      this.scrollToText(key);
    },
    onClickMenu() {
      this.menuOpen = !this.menuOpen;
    },
    onClickMenuClose() {
      this.menuOpen = false;
    },
    onClickTop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style scoped>
div.parent {
  width: 100%;
  height: 100%;
  padding-bottom: 50px;
}
div.gnb {
  position: fixed;
  bottom: 0px;
  left: 0px;
  width: 100%;
  background-color: rgb(228, 228, 228);
  z-index: 1000;
  border-top: 1px solid #ccc;
}
div.gnb ul {
  display: flex;
}
div.gnb ul li {
  flex: 1;
  text-align: center;
  padding: 0px 0px;
}
div.gnb ul li button {
  width: 100%;
  height: 100%;
  padding: 2px 0px;
  color: #343434;
  font-size: 12px;
  border: none;
  text-align: center;
}
div.gnb ul li button img {
  display: block;
  margin: auto;
}
div.gnb ul li button span {
  display: block;
}
div.menu_wrap {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: #f4f4f4;
  z-index: 999;
}
div.menu {
  padding: 15px 0px;
}
div.logo_title {
  padding: 15px 15px;
}
div.logo_img {
  display: flex;
}
div.logo_img button {
  flex: none;
  border: none;
  background: none;
}
div.title_txt {
  font-size: 20px;
}
div.menu_list {
}
div.menu_list ul {
  margin-top: 40px;
  display: grid;
  grid-template-columns: 20% 20% 20% 20% 20%;
}
div.menu_list ul li {
  border: none;
  background: none;
  margin: 15px 0px;
  text-align: center;
}
div.menu_list ul li button {
  padding: 0px;
  height: 70px;
  border: none;
  background: none;
  line-height: 15px;
}
div.menu_list ul li button img {
  display: block;
  margin: 0px auto 5px auto;
}
div.menu_list ul li button span {
  display: block;
  font-size: 12px;
}
div.top_button {
  position: fixed;
  bottom: 65px;
  right: 5px;
}
div.top_button button {
  background-color: #f4f4f4;
  border: 1px solid #ddd;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  padding: 5px;
  text-align: center;
  z-index: 9999;
}
</style>
